import React from "react";
import '../../../App.scss';
import backgroundImage from "../../../assets/images/main_background.png";
import Grid from "@material-ui/core/Grid";
import Toolbar from "../../Toolbar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Result from "../../pageComponents/Home/Question/Result";
import HeaderBackgroundImage from "../../../assets/images/saturn.png";

import PrizeBackground from "../../../assets/images/back.png";
import Tamrin from "../../../assets/images/tamrin.png";
import Button from "../../pageComponents/Settings/Free/Button";
import Polygon from "../../pageComponents/Home/GiftHall/Polygon";
import Treasure from "../../../assets/images/speacialDiscountTreasure.png";
import HorizontalDivider from "../../pageComponents/Home/GiftHall/HorizontalDivider";

class QuestionResult extends React.Component{
    constructor() {
        super()
        this.state= {
            appHasLoaded: false,
            showDialog:false,
            type:false,
            time:null,
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor:"#343168",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0',
                    overflowY:'hidden'
                },
            }
        }
    }
    componentDidMount() {
        this.props.toggleBottomNavbar()
    }
    render() {
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        const hallButton={
            text:'برو به تالار',
            backgroundColor:'gray',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'#000000'
        }
        const polygon= {
            icon: Treasure,
            text: '6',
            textColor: 'yellow',
            locked: false,
            hasGlowBackground: false,
        }
        const divider={
            type:'horizontal'
        }
        const badge={
            conditionValue:20
        }
        return(
            <Grid style={this.state.style.root}  alignItems={"center"} direction={"column"} item container>
                <Dialog
                    open={this.state.showDialog}
                    // open={true}
                    // disableBackdropClick
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'red !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent style={{display:'flex',alignItems:'center'}}>
                        <Result/>
                    </DialogContent>
                </Dialog>
                <Grid item sm={12} justify={'center'} container direction={"column"} style={{flex:'1',minHeight:'0'}}>
                    <Grid item container id={"TTT"}>
                        <Toolbar type='sideToolbar'/>
                    </Grid>
                    <Grid item direction={"column"} container wrap={"nowrap"} className='scrollBar'
                          style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                        <Grid justify={"center"} container xs={12} sm={12}/>
                    </Grid>
                    <Grid item className='question-result-bottom-section' alignItems={"center"} container justify={"center"} >
                        <Grid container alignItems={"center"} item sm={3} xs={3} style={{position:'absolute',top:'-65%',zIndex:'10'}}>
                            <Polygon data={polygon}/>
                        </Grid>
                        <Grid justify={"space-around"} alignItems={"center"} container style={{
                            backgroundImage:`url(${HeaderBackgroundImage})`,
                        }}
                              className='question-result-bottom-section'
                        >
                            <Grid item sm={5} xs={5} style={{height:'50px'}}>
                                <HorizontalDivider data={badge}/>
                            </Grid>
                            <Grid container alignItems={"center"} item sm={3} xs={3} style={{height:'70px'}}>
                                {
                                    this.state.type===true &&
                                    <p style={{textAlign:'center',fontSize:'20px'}}>
                                        19 سوال دیگه باید جواب بدی
                                    </p>
                                }
                                {
                                    this.state.type !== true &&
                                    <Button data={hallButton}/>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default  QuestionResult